import { ContactCornSchema } from '@eigtech/contacts-types';
import { TemplateCornSchema } from '@eigtech/templates-types';
import { z } from 'zod';
export const GuidedDocumentTypeSchema = z.enum([
    'GENERAL_LOSS_REPORT',
    'PROPERTY_INSPECTION_REPORT',
    'SETTLEMENT_LETTER_APPROVAL',
    'SETTLEMENT_LETTER_DENIAL',
    'SETTLEMENT_LETTER_LBD_PARTIAL_DENIAL',
    'SETTLEMENT_LETTER_LBD',
    'SETTLEMENT_LETTER_PA_ATTORNEY_APPROVAL',
    'SETTLEMENT_LETTER_PARTIAL_DENIAL',
    'SETTLEMENT_LETTER_SUPPLEMENT_AND_RELEASE',
]);
export const GuidedDocumentType = GuidedDocumentTypeSchema.enum;
export const GuidedDocumentTemplateSchema = z.object({
    carrierContactCorn: ContactCornSchema,
    templateId: TemplateCornSchema,
    type: GuidedDocumentTypeSchema,
});
